/**
 * 通用资源批量上传常量。
 * ZIP 条目规则与后端 MusicCmdExe 保持一致，便于前后端校验口径统一。
 */

/** 须做内容级补检的旧严格类型（JSON 可解析 / recipe_v2 文件数）；文件名契约已由 zip-only + inspectZipStructure 覆盖 */
export const ZIP_STRICT_TYPES = [
  'recipe(食谱)',
  'puzzle(拼图)',
  'level(关卡)',
  'recipe_v2'
]

/** 不参与批量上传的类型 */
export const NON_FILE_TYPES = ['coupon(优惠券)', 'web(网页)', 'ai_assistant']

export const ASSET_UPLOAD_BUSINESS_TYPE = 'music'

/** 上云 / 落库并发上限 */
export const UPLOAD_CONCURRENCY = 4

/** 前端校验要整包解压，几百个包同时校验会把浏览器内存撑满。 */
export const VALIDATE_CONCURRENCY = 4

/** 从批次 zip 拆包的并发：Finder 打的批次要逐个解压。 */
export const BATCH_OPEN_CONCURRENCY = 4

/** 上云自动重试次数（不含首次） */
export const CLOUD_MAX_RETRY = 3

/** 重试退避毫秒 */
export const CLOUD_RETRY_DELAYS_MS = [1000, 2000, 4000]

/** Recipe zip 条目 */
export const RECIPE_PREVIEW_PREFIX = 'preview.'
export const RECIPE_COVER_PREFIX = 'cover.'
export const RECIPE_CONTENT = 'content.md'

/** Puzzle zip 条目 */
export const PUZZLE_IMAGE_PREFIX = 'image.'
export const PUZZLE_PREVIEW_PREFIX = 'preview.'

/** Level zip 条目 */
export const LEVEL_IMAGE1_PREFIX = 'image1.'
export const LEVEL_IMAGE2_PREFIX = 'image2.'
export const LEVEL_CONFIG = 'config.json'

/** Recipe_v2 zip 条目 */
export const RECIPE_V2_PREVIEW_SUFFIX = '_preview.jpg'
export const RECIPE_V2_JSON_SUFFIX = '.json'
